<template>
    <div class="p-4 lg:w-full md:w-full">
        <div class="grid grid-cols-1 gap-4">
            <div class="field w-full mb-4 flex items-center">
                <JetLabel
                    class="w-1/3 my-2"
                    value="Metode Penyampaian Dokumen"
                />
                <div class="w-2/3">
                    <div class="flex gap-4">
                        <div class="flex items-center">
                            <input
                                type="radio"
                                id="2f"
                                v-model="metodePenyampaian"
                                value="2f"
                                class="mr-2"
                                @change="updateMetode"
                                onclick="return false;"
                            />
                            <input type="hidden" :name="'metode_penyampaian'" :value="metodePenyampaian === '2f' ? '2f' : ''">
                            <label for="2f">2 file</label>
                        </div>
                        <div class="flex items-center">
                            <input
                                type="radio"
                                id="1f"
                                v-model="metodePenyampaian"
                                value="1f"
                                class="mr-2"
                                @change="updateMetode"
                                onclick="return false;"
                            />
                            <input type="hidden" :name="'metode_penyampaian'" :value="metodePenyampaian === '1f' ? '1f' : ''">
                            <label for="1f">1 file</label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bobot fields based on metode penyampaian -->
            <div v-if="metodePenyampaian === '1f'" class="field w-full mb-4 flex items-center">
                <JetLabel
                    class="w-1/3 my-2"
                    value="Bobot Keseluruhan (%)"
                />
                <div class="w-2/3">
                    <input
                        type="number"
                        v-model="bobotKeseluruhan"
                        class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full"
                        min="0"
                        max="100"
                        readonly
                        @input="updateBobotKeseluruhan"
                    />
                </div>
            </div>
            <div v-if="metodePenyampaian === '1f'" class="field w-full mb-4 flex items-center">
                <JetLabel
                    class="w-1/3 my-2"
                    value="Bobot Kualifikasi (%)"
                />
                <div class="w-2/3">
                    <input
                        type="number"
                        v-model="bobotKualifikasi"
                        class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full"
                        min="0"
                        max="100"
                        readonly
                        @input="updateBobotKualifikasi"
                    />
                </div>
            </div>

            <template v-if="metodePenyampaian === '2f'">
                <div class="field w-full mb-4 flex items-center">
                    <JetLabel
                        class="w-1/3 my-2"
                        value="Bobot Teknis (%)"
                    />
                    <div class="w-2/3">
                        <input
                            type="number"
                            v-model="bobotTeknis"
                            class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full bg-gray-100"
                            min="0"
                            max="100"
                            @input="updateBobot"
                            readonly
                        />
                    </div>
                </div>

                <div class="field w-full mb-4 flex items-center">
                    <JetLabel
                        class="w-1/3 my-2"
                        value="Bobot Harga (%)"
                    />
                    <div class="w-2/3">
                        <input
                            type="number"
                            v-model="bobotHarga"
                            class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full bg-gray-100"
                            min="0"
                            max="100"
                            @input="updateBobot"
                            readonly
                        />
                    </div>
                </div>

                <div v-if="bobotError" class="text-red-500 text-sm ml-1/3 pl-4">
                    {{ bobotError }}
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, watch, computed } from "vue";
import JetLabel from "@/Jetstream/Label";

export default defineComponent({
    name: 'MetodePenyampaianForm',
    components: {
        JetLabel,
    },
    props: {
        metode: {
            type: String,
            default: '2f'
        },
        bobotTeknis: {
            type: Number,
            default: 60
        },
        bobotHarga: {
            type: Number,
            default: 40
        },
        bobotKeseluruhan: {
            type: Number,
            default: 50
        },
        bobotKualifikasi: {
            type: Number,
            default: 50
        }
    },
    emits: ['update:metode', 'update:bobotTeknis', 'update:bobotHarga', 'update:bobotKeseluruhan', 'update:bobotKualifikasi'],
    setup(props, { emit }) {
        const metodePenyampaian = computed({
            get: () => props.metode,
            set: (value) => emit('update:metode', value)
        });
        
        const bobotTeknis = computed({
            get: () => props.bobotTeknis,
            set: (value) => emit('update:bobotTeknis', Number(value))
        });
        
        const bobotHarga = computed({
            get: () => props.bobotHarga,
            set: (value) => emit('update:bobotHarga', Number(value))
        });
        
        const bobotKeseluruhan = computed({
            get: () => props.bobotKeseluruhan,
            set: (value) => emit('update:bobotKeseluruhan', Number(value))
        });

        const bobotKualifikasi = computed({
            get: () => props.bobotKualifikasi,
            set: (value) => emit('update:bobotKualifikasi', Number(value))
        });

        const bobotError = ref('');

        const updateMetode = () => {
            if (metodePenyampaian.value === '1f') {
                emit('update:bobotKeseluruhan', 50);
                emit('update:bobotTeknis', 0);
                emit('update:bobotHarga', 0);
                emit(
                    'update:bobotKualifikasi',
                    50
                )
            } else {
                emit('update:bobotKeseluruhan', 0);
                emit('update:bobotTeknis', 0);
                emit('update:bobotHarga', 0);
                emit(
                    'update:bobotKualifikasi',
                    0
                )
            }
        };

        const updateBobot = () => {
            if (metodePenyampaian.value === '2f') {
                const total = Number(bobotTeknis.value) + Number(bobotHarga.value);
                if (total > 100) {
                    bobotError.value = 'Total bobot tidak boleh melebihi 100%';
                    // Adjust the values to ensure total doesn't exceed 100
                    if (bobotTeknis.value > 0) {
                        emit('update:bobotTeknis', Math.max(0, 100 - Number(bobotHarga.value)));
                    } else if (bobotHarga.value > 0) {
                        emit('update:bobotHarga', Math.max(0, 100 - Number(bobotTeknis.value)));
                    }
                } else {
                    bobotError.value = '';
                }
            }
            if (metodePenyampaian.value === '1f') {
                const total = Number(bobotKeseluruhan.value);
                if (total > 100) {
                    bobotError.value = 'Total bobot tidak boleh melebihi 100%';
                    // Adjust the values to ensure total doesn't exceed 100
                    if (bobotKeseluruhan.value > 0) {
                        emit('update:bobotKeseluruhan', Math.max(0, 100) - Number(bobotKualifikasi.value));
                    } else if (bobotKualifikasi.value > 0) {
                        emit('update:bobotKualifikasi', Math.max(0, 100) - Number(bobotKeseluruhan.value));
                    }
                } else {
                    bobotError.value = '';
                }
            }
        };

        const updateBobotKeseluruhan = () => {
            if (Number(bobotKeseluruhan.value) > 100) {
                bobotKeseluruhan.value = 100;
            }
        };

        return {
            metodePenyampaian,
            bobotKeseluruhan,
            bobotKualifikasi,
            bobotTeknis,
            bobotHarga,
            bobotError,
            updateBobot,
            updateMetode,
            updateBobotKeseluruhan
        };
    }
});
</script>
